import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IUser } from './select-users-to-share.models';
import { UsersService } from '../../users/users.service';

@Component({
  selector: 'app-select-users-to-share',
  templateUrl: './select-users-to-share.component.html',
  styleUrls: ['./select-users-to-share.component.scss'],
  animations: [
    trigger('selectedUser', [
      state('void', style({
        opacity: 0,
        transform: 'translateX(-100%)'
      })),
      state('*', style({
        opacity: 1,
        transform: 'translateX(0)'
      })),
      transition('void => *', animate('0.2s ease-in')),
      transition('* => void', animate('0.1s ease-in'))
    ])
  ]
})
export class SelectUsersToShareComponent implements OnInit {

  @Input() visible = false;
  @Input() visibleCopyLink = false;
  @Input() dashboardId: number = null;
  @Input() userName: string = null;
  @Output() isOpen = new EventEmitter<boolean>();
  @Output() shareUsers = new EventEmitter<IUser[]>();
  @ViewChild('inputForLink', { static: false }) inputForLink: ElementRef;

  users: IUser[] = [];
  selectedUsers: IUser[] = [];
  allUsers: IUser[] = [];
  searchString = '';
  hasSelectedItems: boolean;

  loadedUsers = false;
  linkToCopy = '';
  hoursString = '6';
  hoursModal = false;
  linkCopiedError = false;
  linkCopiedSuccess = false;
  result: boolean;

  constructor(
    private userService: UsersService
  ) { }

  ngOnInit() {
    if (this.visibleCopyLink) {
      this.createLink();
    }
    this.userService.getDashboardUsers().subscribe((value: IUser[]) => {
      this.allUsers = value.filter(x => x.userName !== this.userName);
      this.allUsers.map(user => {
        if (user.firstName === undefined || user.firstName === null) {
          user.firstName = '';
        }
        if (user.lastName === undefined || user.lastName === null) {
          user.lastName = '';
        }
        user.selected = false;
      });

      this.users = [...this.allUsers];
      this.loadedUsers = true;
    });
    // this.provider.getUsers().then((value: IUser[]) => {
    //   this.allUsers = value.filter(x => x.userName !== this.authService.getUserName());
    //   this.allUsers.map(user => {
    //     if (user.firstName === undefined || user.firstName === null) {
    //       user.firstName = '';
    //     }
    //     if (user.lastName === undefined || user.lastName === null) {
    //       user.lastName = '';
    //     }
    //     user.selected = false;
    //   });

    //   this.users = [...this.allUsers];
    //   this.loadedUsers = true;
    // });
  }

  closeModal() {
    this.isOpen.emit(false);
    this.visible = false;
  }

  selectUser(usr: IUser) {
    usr.selected = !usr.selected;

    this.selectedUsers = this.allUsers
      .filter(user => user.selected)
      .sort((left: IUser, right: IUser): any => {
        if (left.firstName > right.firstName) { return 1; } else { return -1; }
      });
    this.hasSelectedItems = this.selectedUsers.length > 0;

    const unSelectedUsers = this.allUsers
      .filter(user => !user.selected)
      .sort((left: IUser, right: IUser): any => {
        if (left.firstName > right.firstName) { return 1; } else { return -1; }
      });

    if (this.searchString !== '') {
      this.changeSearchString();
    } else {
      this.users = [...unSelectedUsers];
    }
  }

  share() {
    if (this.selectedUsers.length > 0) {
      this.shareUsers.emit([...this.selectedUsers]);
    }
  }

  openHoursModal() {
    this.hoursModal = true;
  }

  createLink() {
    // this.linkCopiedSuccess = false;
    // this.provider.shareDashboardLink(this.dashboardId, Number(this.hoursString))
    //   .then((link) => {
    //     this.linkToCopy = link;
    //   })
    //   .catch((error) => {
    //     console.error('--- Не получилось сгенерировать ссылку --- ', error);
    //   });
  }

  copyLink() {
    this.inputForLink.nativeElement.select();

    let successful;
    try {
      successful = document.execCommand('copy');
      if (successful) {
        this.linkCopiedSuccess = true;
        this.linkCopiedError = false;
      } else {
        this.linkCopiedError = true;
        this.linkCopiedSuccess = false;
      }
    } catch (err) {
    } finally {
    }
  }

  changeSearchString() {
    if (this.searchString !== '') {
      this.users = this.allUsers.filter(user => {
        const fullName = (user.firstName + ' ' + user.lastName).toLowerCase();
        return fullName.includes(this.searchString.toLowerCase()) && !user.selected;
      })
        .sort((left: IUser, right: IUser): any => {
          if (left.firstName > right.firstName) { return 1; } else { return -1; }
        });
    } else {
      this.users = [...this.allUsers
        .filter(user => !user.selected)
        .sort((left: IUser, right: IUser): any => {
          if (left.firstName > right.firstName) { return 1; } else { return -1; }
        })];
    }
  }

}
